import { environment } from 'src/environments/environment';

export const DEFAULT_CLIENT = 'gmu';

export function getStaticBasePath(): string {
  return environment.STATIC_BASE_PATH ?? '';
}

export function getContentBasePath(): string {
  const base = getStaticBasePath();
  return base ? `${base}/content` : '/content';
}

export function getI18nBasePath(): string {
  const base = getStaticBasePath();
  return base ? `${base}/i18n` : '/i18n';
}

export function getClienteApiUrl(): string {
  return `${environment.API_URL}/api/cliente`;
}

export function getClientImagePath(imageFolder: string, fileName: string): string {
  return `${getContentBasePath()}/images/${imageFolder}/${fileName}`;
}
